// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableDetailsQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
}>;

export type SchemaTableDetailsQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableDetails: {
    __typename?: "SchemaTable";
    id: string;
    schemaName: string;
    tableName: string;
    relationType: string;
    fillfactor?: number | null;
    partitionBoundary?: string | null;
    partitionedBy?: string | null;
    parentTable?: {
      __typename?: "SchemaTable";
      id: string;
      schemaName: string;
      tableName: string;
    } | null;
    lastStats?: {
      __typename?: "SchemaTableInlineStats";
      snapshotAt?: number | null;
      dataSizeBytes?: number | null;
      indexSizeBytes?: number | null;
      liveTuples?: number | null;
      deadTuples?: number | null;
    } | null;
    stats7dAgo?: {
      __typename?: "SchemaTableInlineStats";
      snapshotAt?: number | null;
      dataSizeBytes?: number | null;
    } | null;
  };
};

export const SchemaTableDetailsDocument = gql`
  query SchemaTableDetails($databaseId: ID!, $tableId: ID!) {
    getSchemaTableDetails(databaseId: $databaseId, schemaTableId: $tableId) {
      id
      schemaName
      tableName
      relationType
      fillfactor
      parentTable {
        id
        schemaName
        tableName
      }
      partitionBoundary
      partitionedBy
      lastStats {
        snapshotAt
        dataSizeBytes
        indexSizeBytes
        liveTuples
        deadTuples
      }
      stats7dAgo {
        snapshotAt
        dataSizeBytes
      }
    }
  }
`;

/**
 * __useSchemaTableDetailsQuery__
 *
 * To run a query within a React component, call `useSchemaTableDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableDetailsQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useSchemaTableDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  > &
    (
      | { variables: SchemaTableDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  >(SchemaTableDetailsDocument, options);
}
export function useSchemaTableDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  >(SchemaTableDetailsDocument, options);
}
// @ts-ignore
export function useSchemaTableDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableDetailsQuery,
  SchemaTableDetailsQueryVariables
>;
export function useSchemaTableDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableDetailsQuery,
        SchemaTableDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableDetailsQuery | undefined,
  SchemaTableDetailsQueryVariables
>;
export function useSchemaTableDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableDetailsQuery,
        SchemaTableDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableDetailsQuery,
    SchemaTableDetailsQueryVariables
  >(SchemaTableDetailsDocument, options);
}
export type SchemaTableDetailsQueryHookResult = ReturnType<
  typeof useSchemaTableDetailsQuery
>;
export type SchemaTableDetailsLazyQueryHookResult = ReturnType<
  typeof useSchemaTableDetailsLazyQuery
>;
export type SchemaTableDetailsSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableDetailsSuspenseQuery
>;
export type SchemaTableDetailsQueryResult = Apollo.QueryResult<
  SchemaTableDetailsQuery,
  SchemaTableDetailsQueryVariables
>;
